import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedUiModule } from '../shared-ui/shared-ui.module';
import { AuthModule } from '../users/auth.module';

import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { NavlistComponent } from "../navlist/navlist.component";
import { SideNavContentComponent } from '../users/side-nav-content/side-nav-content.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavlistComponent,
    SideNavContentComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedUiModule,
    AuthModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    NavlistComponent,
    SideNavContentComponent
  ]
})
export class CoreModule { }
